import { Grid } from "@mui/material";
import FormattedDatePicker from "components/common/FormattedDatePicker";
import { useRetroactiveDateSupport } from "components/layers/retroactiveDateSupport";
import * as labels from "config.labels";
import { useDispatch } from "react-redux";
import * as pricingActions from "store/actions/pricing/pricingActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";

/**
 * Layer-level retroactive date picker. Rendered only when the active layer's
 * selected policy type OR policy form is configured with
 * `hasRetroactiveDate: true`. Writes to `layer.retroactiveDate`.
 */
const RetroactiveDate = ({ disabled }) => {
  const dispatch = useDispatch();
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const { supported, layer } = useRetroactiveDateSupport();

  if (!supported) {
    return null;
  }

  return (
    <Grid item xs={12} key={`${layer?.policyType}-${layer?.policyForm}`}>
      <FormattedDatePicker
        label={translateLabel(labels.POLICY_TYPE_RETRO_DATE_LABEL, {
          default: "Retroactive Date",
        })}
        value={layer?.retroactiveDate ?? ""}
        onChangeDate={(date) =>
          dispatch(
            pricingActions.updateLayer({
              layerId: layer.id,
              values: { retroactiveDate: date },
            })
          )
        }
        disabled={disabled}
      />
    </Grid>
  );
};

export default RetroactiveDate;
